"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TabsList = void 0;
const graph_1 = require("@components/graph");
const loader_1 = require("@components/loader");
const tab_content_1 = require("@components/tab-content");
const tabs_slider_1 = require("@components/tabs-slider");
const object_1 = require("@utils/object");
const react_1 = __importDefault(require("react"));
require("./styles.scss");
const TabsList = (props) => {
    const { removeTab, activeTabIndex, setActiveTabIndex, sliderData, tabContent, directTransactions, isLoading } = props;
    return (react_1.default.createElement("div", { className: "c-tabs-list-wrapper" },
        react_1.default.createElement("div", { className: "c-tabs-list" },
            react_1.default.createElement(tabs_slider_1.TabsSlider, { activeTabIndex: activeTabIndex, onSelect: setActiveTabIndex, transfers: sliderData, removeTab: removeTab }),
            !tabContent[0] && isLoading ? (react_1.default.createElement(loader_1.Loader, null)) : (tabContent.map((item, index) => {
                const isCurrentTab = index + 1 === activeTabIndex;
                const isCurrentTabEmpty = !tabContent[activeTabIndex];
                if (isLoading && isCurrentTab && isCurrentTabEmpty) {
                    return react_1.default.createElement(loader_1.Loader, null);
                }
                else if ((0, object_1.caseInsensitiveCompare)(sliderData[activeTabIndex], item.wallet)) {
                    return directTransactions.map((el) => {
                        if (el.wallet === item.wallet) {
                            return (react_1.default.createElement("div", { className: "c-tabs-info", key: crypto.randomUUID() },
                                react_1.default.createElement("div", { className: "c-tabs-graph" },
                                    react_1.default.createElement(graph_1.CustomGraph, { tabContent: item.tokenTransfers, wallet: item.wallet, directTransactions: el.directTransactions })),
                                react_1.default.createElement("div", { className: "c-tabs-transfers" },
                                    react_1.default.createElement(tab_content_1.TabContent, { transfers: item.tokenTransfers }))));
                        }
                    });
                }
            })))));
};
exports.TabsList = TabsList;
